import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  sectionMargins,
  standardColours,
} from '../styles';
import { ArrowLink, Container } from './ui';

const StyledBlogAuthor = styled.section`
  ${sectionMargins('20px', '40px')};
`;

const StyledContainer = styled(Container)`
  padding-left: 0;
  padding-right: 0;
`;

const StyledInner = styled.div`
  border-radius: 20px;
  border: solid 1px ${standardColours.lighterGrey};
  padding: 30px;

  ${minBreakpointQuery.small`
    padding: 35px;
  `}

  ${minBreakpointQuery.medium`
    padding: 40px;
  `};

  ${minBreakpointQuery.large`
    padding: 45px;
  `};

  ${minBreakpointQuery.xxlarge`
    padding: 50px;
  `};
`;

const StyledHeading = styled.h2`
  ${fontSize(21)};
  line-height: 1.4;
  font-weight: ${fontWeights.semibold};
  color: ${brandColours.secondary};

  ${minBreakpointQuery.small`
    ${fontSize(23)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(25)};
  `};
`;

const StyledTop = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const StyledImage = styled(GatsbyImage)`
  border-radius: 50%;
  width: 60px;
  height: 60px;
`;

const StyledText = styled.p`
  white-space: break-spaces;
  margin-top: 20px;
  line-height: 1.7;

  ${minBreakpointQuery.small`
    ${fontSize(18)};
  `}
`;

const StyledLink = styled(ArrowLink)`
  margin-top: 40px;

  ${minBreakpointQuery.small`
    a {
      ${fontSize(18)};
    }
  `}

  ${minBreakpointQuery.large`
    a {
      ${fontSize(20)};
    }
  `}
`;

const BlogAuthor = author => {
  const { image, title, biography } = author;

  return (
    <StyledBlogAuthor>
      <StyledContainer narrower={true}>
        <StyledInner>
          <StyledTop>
            <StyledImage image={image.gatsbyImageData} alt={image.alt} />
            <StyledHeading>{title}</StyledHeading>
          </StyledTop>
          <StyledText>{biography}</StyledText>
          <StyledLink to={author} alt={true}>
            More by {title}
          </StyledLink>
        </StyledInner>
      </StyledContainer>
    </StyledBlogAuthor>
  );
};

export default BlogAuthor;
